<template>
  <div class="product-item">
    <bg-intro :bg="bg" class="bg-wrapper">
      <div class="video-intro">
        <h2>低码率语音压缩算法</h2>
        <p>
          常规的窄宽卫星通信的容量较少，一般情况下只能发送文本内容。在此背景下，通过突破高压缩比的语音编码和解码技术，设计低延时的语音数据调度协议，实现用户间点对点连续语音对讲，以及用户和后台、用户间即时回传。
        </p>
        <a class="btn-wrapper" href="#video">
          <div class="btn-content space-between">
            <img src="../../assets/product/play.svg" alt="play" />
            <span>点击视频了解</span>
          </div>
        </a>

        <!-- <div class="code-wrapper">
          <img class="qr-code" src="@/assets/product/demo.png" alt="" />
        </div> -->
      </div>
    </bg-intro>

    <div class="achievement">
      <div class="img-wrapper space-between">
        <img src="../../assets/product/zd.png" alt="重大专项" />
        <img src="../../assets/product/zhongda.webp" alt="中山大学" />
        <img src="../../assets/product/zdlogo.png" alt="中山大学" />
      </div>
      <h5><b>依托北斗重大专项应用推广与产业化项目</b></h5>
      <h5>中山大学CPNT Lab研发成功，成熟应用，稳定可靠</h5>
    </div>

    <field :fieldData="fieldData" bg="#F6F7F8"></field>

    <div class="video-wrapper" id="video">
      <h3>演示视频</h3>
      <!-- <video controls width="1200">
        <source :src="`${baseUrl}/api/console/files/material/video/bd-short-msg-show-video.mp4`" type="video/mp4" />
      </video> -->
      <div class="video-wrapper">
        <iframe
          class="iframe-video"
          src="//player.bilibili.com/player.html?aid=0d79e83613d7a978665fe6368a98e7ee&bvid=BV1CtqrYxEdh&cid=&page=1&as_wide=0&danmaku=0"
          width="1200"
          height="744.34"
          scrolling="no"
          border="0"
          frameborder="no"
          framespacing="0"
          allowfullscreen="true"
        ></iframe>
      </div>
    </div>

    <highlight :highlightsData="highlightData"></highlight>

    <practice :practiceData="practiceData"></practice>

    <div class="brief-wrapper">
      <h3>关键技术</h3>
      <brief :briefData="briefData[0]" :isReverse="true"></brief>
      <brief :briefData="briefData[1]" :isReverse="false"></brief>
      <brief :briefData="briefData[2]" :isReverse="true"></brief>
    </div>
    <product title="适用设备"></product>
    <beDevelop></beDevelop>
  </div>
</template>

<script>
import bgIntro from '@/components/common/product/bgIntro.vue';
import field from '@/components/common/solution/field.vue';
import highlight from '@/components/common/solution/highlight.vue';
import brief from '@/components/common/solution/brief.vue';
import product from '@/components/common/solution/product.vue';
import beDevelop from '@/components/common/beDevelop.vue';
import practice from '@/components/common/practice.vue';
import config from '@/config';
export default {
  metaInfo: {
    title: '低码率语音压缩算法-低码率高清晰，技术领先',
    meta: [
      {
        name: 'keywords',
        content: '窄带语音压缩,低码率语音压缩算法,北斗收发语音,卫星语音通话',
      },
      {
        name: 'description',
        content:
          '北斗卫星语音压缩算法极致压缩比：采样率8kHz， 码率是450bps， 使用北斗三号五级卡（1750字节）情况下，最长能传输31秒语音。集成学习的波速形成语音增强算法，能清晰分辨男声或女声，分辨使用者身份。',
      },
    ],
  },
  data() {
    return {
      baseUrl: config.baseUrl,
      bg: require('../../assets/product/voicebanner.webp'),
      fieldData: {
        fieldTitle: '应用领域',
        items: [
          {
            id: 'field1',
            imgSrc: require('../../assets/product/xuqiu1.webp'),
            intro1: '窄宽通信卫星通信容量有限',
            intro2: '只能发送文字内容',
          },
          {
            id: 'field2',
            imgSrc: require('../../assets/product/xuqiu2.webp'),
            intro1: '应急通信时文字输入效率低',
            intro2: '无法满足实际应用需求',
          },
          {
            id: 'field3',
            imgSrc: require('../../assets/product/xuqiu3.webp'),
            intro1: '企事业单位自研语音压缩技术耗时',
            intro2: '耗力，效果不佳',
          },
        ],
      },
      highlightData: {
        title: '服务优势',
        items: [
          {
            id: 'h1',
            title: '极致压缩比',
            intro: '采样率8kHz， 码率是256bps， 使用北斗三号五级卡（1750字节）情况下，最长能传输56秒语音。',
            imgSrc: require('../../assets/solution/yyys-fuzb1.webp'),
            color: '#EFA65E',
          },
          {
            id: 'h2',
            title: '超高压缩效率',
            intro: '从语音输入到压缩完成，整个过程仅需200毫秒。',
            imgSrc: require('../../assets/solution/yyys-fuzb2.webp'),
            color: '#63B59F',
          },
          {
            id: 'h3',
            title: '高保真效果',
            intro: '集成学习的波速形成语音增强算法，能清晰分辨男声或女声，分辨使用者身份。',
            imgSrc: require('../../assets/solution/yyys-fuzb3.webp'),
            color: '#4173FB',
          },
        ],
      },
      briefData: [
        {
          title: '语音过渡段清/浊音判决技术',
          imgSrc: require('../../assets/solution/guanjian1.webp'),
          introItems: [
            {
              id: 'intro1',
              // subtitle: '平板应用app支持全国卫星/标准离线地图下载，储存在平板电脑本地；  ',
              intro:
                '基于上采样的基音周期估计算法，过渡段清/浊音判决以及基于过渡段的非对称窗LPC分析方法，有效提升语音质量。',
            },
          ],
        },
        {
          title: '波束形成与深度学习相结合的语音增强算法',
          imgSrc: require('../../assets/solution/guanjian2.webp'),
          introItems: [
            {
              id: 'intro1',
              // subtitle: '复高斯混合模型估计时频掩蔽和方向矢量',
              intro: '利用复高斯混合模型估计时频掩蔽和方向矢量的波束形成方法，有效去除环境噪声，增强语音效果。',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
          ],
        },
        {
          title: '低码率环境高效可靠语音传输协议优化技术',
          imgSrc: require('../../assets/solution/guanjian3.webp'),
          introItems: [
            {
              id: 'intro1',
              intro:
                '基于编码冗余的抗长延时语音传输协议；自适应信道速率的动态分包算法；基于遗传算法的链路资源智能调度策略。有效支持丢包重传，支持用户动态调整，提高传输效率。',
              // intro: '北斗船载终端定时5分钟/次（可调）向后台上报终端位置信息',
            },
          ],
        },
      ],
      practiceData: {
        title: '应用场景',
        items: [
          {
            id: '战术通信指挥调度',
            intro: '战术通信指挥调度',
            imgSrc: require('../../assets/product/yingyong1.webp'),
          },
          {
            id: '电力巡检应急通信',
            intro: '电力巡检应急通信',
            imgSrc: require('../../assets/product/yingyong2.webp'),
          },
          {
            id: '国家地质公园卫星语音一键呼叫',
            intro: '国家地质公园卫星语音一键呼叫',
            imgSrc: require('../../assets/product/yingyong3.webp'),
          },
          {
            id: '森林消防应急位置追踪',
            intro: '森林消防应急位置追踪',
            imgSrc: require('../../assets/product/yingyong4.webp'),
          },
        ],
      },
    };
  },

  components: {
    bgIntro,
    field,
    highlight,
    brief,
    product,
    beDevelop,
    practice,
  },
};
</script>

<style lang="scss" scoped>
.product-item {
  width: 100%;
  .achievement {
    margin-top: 50px;
    margin-bottom: 50px;
    .img-wrapper {
      width: 600px;
      margin: 0 auto;
      img {
        max-width: 200px;
      }
    }
    h5 {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
      color: #0d0e24;
      line-height: 30px;
      margin-top: 20px;
    }
  }

  .video-wrapper {
    width: 1200px;
    margin: 50px auto;
    h3 {
      text-align: center;
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      margin-bottom: 50px;
    }
    // video {
    //   text-align: center;
    // }
    // .video-wrapper {
    //   position: relative;
    //   margin-bottom: 1em;
    //   padding-bottom: 56.25%;
    //   height: 0;
    //   overflow: hidden;
    //   max-width: 100%;
    //   iframe,
    //   object,
    //   embed {
    //     position: absolute;
    //     top: 0;
    //     left: 0;
    //     width: 100%;
    //     height: 100%;
    //   }
    // }
  }

  .brief-wrapper {
    margin-top: 70px;
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #0d0e24;
      text-align: center;
    }
  }
}
@media only screen and (max-width: 1440px) {
  .code-wrapper {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    .qr-code {
      margin-top: 20px;
      margin-left: 150px;
      width: 100px;
      height: 100px;
    }
  }
}
@media only screen and (min-width: 1441px) {
  .code-wrapper {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    .qr-code {
      margin-top: 40px;
      margin-left: 150px;
      width: 120px;
      height: 120px;
    }
  }
}
</style>